.warningTextContainer {
    display: flex;
    justify-content: end;
    margin: 5px 0px;
}